import React from 'react';
import { Col } from 'react-bootstrap';
import { Link } from 'react-scroll';

import avatarIcon from 'images/directory/avatar_icon.svg';
import avatarIconHover from 'images/directory/avatar_icon_hover.svg';
import openTo from 'images/directory/opento_icon.svg';
import openToHover from 'images/directory/opento_icon_hover.svg';
import settingsIcon from 'images/directory/settings_icon.svg';
import settingsIconHover from 'images/directory/settings_icon_hover.svg';
import skillIcon from 'images/directory/skill_icon.svg';
import skillIconHover from 'images/directory/skill_icon_hover.svg';
import socialIcon from 'images/directory/social_icon.svg';
import socialIconHover from 'images/directory/social_icon_hover.svg';
import topicIcon from 'images/directory/topic_icon.svg';
import topicIconHover from 'images/directory/topic_icon_hover.svg';
import weekendIcon from 'images/directory/weekend_icon.svg';
import weekendIconHover from 'images/directory/weekend_icon_hover.svg';

const SideNav = () => {
  return (
    <Col className="SideNav col-sm-12 col-md-2 profile-detail-nav">
      <ul className="profile-settings-nav">
        <li>
          <img src={settingsIcon} className="without-hover-state" />
          <img src={settingsIconHover} className="with-hover-state" />
          <Link className="link-nav" activeClass="active" to="Settings" spy={true} smooth={true}>
            Settings
          </Link>
        </li>
        <li>
          <img src={avatarIcon} className="without-hover-state" />
          <img src={avatarIconHover} className="with-hover-state" />
          <Link className="link-nav" activeClass="active" to="Profile" spy={true} smooth={true}>
            Profile
          </Link>
        </li>
        <li>
          <img src={openTo} className="without-hover-state" />
          <img src={openToHover} className="with-hover-state" />
          <Link className="link-nav" activeClass="active" to="Open-To" spy={true} smooth={true}>
            Open To
          </Link>
        </li>
        <li>
          <img src={socialIcon} className="without-hover-state" />
          <img src={socialIconHover} className="with-hover-state" />
          <Link className="link-nav" activeClass="active" to="Social" spy={true} smooth={true}>
            Social
          </Link>
        </li>
        <li>
          <img src={topicIcon} className="without-hover-state" />
          <img src={topicIconHover} className="with-hover-state" />
          <Link className="link-nav" activeClass="active" to="Topics" spy={true} smooth={true}>
            Topics
          </Link>
        </li>
        <li>
          <img src={skillIcon} className="without-hover-state" />
          <img src={skillIconHover} className="with-hover-state" />
          <Link className="link-nav" activeClass="active" to="Skills" spy={true} smooth={true}>
            Skills
          </Link>
        </li>
        <li>
          <img src={weekendIcon} className="without-hover-state" />
          <img src={weekendIconHover} className="with-hover-state" />
          <Link className="link-nav" activeClass="active" to="Weekend" spy={true} smooth={true}>
            Weekend
          </Link>
        </li>
      </ul>
    </Col>
  );
};

export default SideNav;
